import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { Globals } from 'src/app/globals';
import { EnrollmentAcceptedStudentService } from 'src/app/service/enrollmentAcceptedStudent.service';
import { FileService } from 'src/app/service/file.service';

import * as fs from 'file-saver';
import html2canvas from 'html2canvas';
import domtoimage from 'dom-to-image';

// Excel sheet export
import { Cell, Workbook } from 'exceljs';
import { environment } from 'src/environments/environment';
import { Console } from 'console';
import { EnrollmentGroupService } from 'src/app/service/enrollment-group.service';
import { EnrollmentReportService } from 'src/app/service/enrollment-report.service';
declare let pdfMake: any;
declare var $: any;
@Component({
  selector: 'app-enrolment-reports',
  templateUrl: './enrolment-reports.component.html',
  styleUrls: ['./enrolment-reports.component.scss']
})
export class EnrolmentReportsComponent implements OnInit {
  photoPath: any = `${environment.API_URL_UTIL}/api/downloadFile/`;
  studentForm: boolean = true;
  groupForm: boolean = false;
  subjectForm: boolean = false;
  select: any;
  showLoader: boolean = false;
  searchByFields: any;
  students: any;
  table: any;
  courses: any = [];
  studentCoursesModalLoader = false;
  years: any;
  semesters: any;
  batches: any;
  orgId: any;
  username: any;
  tableAppear: boolean = false;
  lastSelectYear: any = 0;
  lastSelectSemester: any = 0;
  lastSelectBatch: any = 0;
  lastSelectBatchName: any = '';
  lastSelectSemesterName: any = '';
  batchStatisticsReport: any = [];

  searchForm = new FormGroup({
    year: new FormControl('', [
      Validators.required,
    ]),
    semester: new FormControl('', [
      Validators.required,
    ]),
    batch: new FormControl('', [
      Validators.required,
    ]),
  });


  constructor(private toastrService: ToastrService, public enrollmentAcceptedStudentService: EnrollmentAcceptedStudentService, public globals: Globals, private router: Router, public translate: TranslateService, private fileService: FileService
    , private enrollmentGroupService: EnrollmentGroupService, private enrollmentReportService: EnrollmentReportService) { }

  ngOnInit(): void {
    this.getYears();
    this.orgId = this.globals.currentUserInfo.orgid;
    this.username = this.globals.currentUserInfo.username;
    // if(this.students.length >= 1){
    //   this.tableAppear=true;
    // }else{
    //   this.tableAppear=false;
    // }

    // this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
    //   this.updateTable();
    //   //this.initFormDropDownsFields();
    // });
  }

  updateTable() {
    let titleValue = 'Academic Year ' + this.lastSelectYear;
    let messageTopValue = this.lastSelectSemesterName + ' , ' + this.lastSelectBatchName + '  Batch.';
    pdfMake.fonts = {
      Arial: {
        normal: 'arial.ttf',
        bold: 'arialbd.ttf',
        italics: 'ariali.ttf',
        bolditalics: 'arialbi.ttf'
      }
    };
    console.log("datatable")
    $("#datatable").DataTable().destroy();
    setTimeout(() => {
      $(document).ready(function () {
        $("#datatable").DataTable({
          dom: 'Bfrtip',
          pagingType: 'simple_numbers',
          // responsive: true,
          // columnDefs: [
          //   { responsivePriority: 1, targets: 0 },
          //   { responsivePriority: 10001, targets: 4 },
          //   { responsivePriority: 2, targets: -2 }
          // ],
          // "columnDefs": [
          //   { "orderable": false, "targets": [1, 2] }
          // ],
          pageLength: 5,
          lengthChange: false,
          info: true,
          search: {
            searchPlaceholder: "Search",
          },
          paging: true,
          language: {
            search: "",
            searchPlaceholder: "Search",
          },
          buttons: [{
            // extend: 'csvHtml5',
            // text: '<span style="font-size: 3em; color: green;"><i class="fas fa-file-excel fa-sm"></i></span>',
            // titleAttr: 'CSV',
            title: titleValue,
            messageTop: messageTopValue,
            extend: 'excelHtml5',
            text: '<span style="font-size: 3em; color: green;"><i class="fas fa-file-excel fa-sm"></i></span>',
            titleAttr: 'enall',
            attr: {
              id: 'enall',
              style: "display:none;",
            },
            exportOptions: {
              columns: [0, 1, 3, 4, 5, 8]
              // columns: [ ':visible' ]
            }
          },
          {
            // extend: 'csvHtml5',
            // text: '<span style="font-size: 3em; color: green;"><i class="fas fa-file-excel fa-sm"></i></span>',
            // titleAttr: 'CSV',
            title: titleValue,
            messageTop: messageTopValue,
            extend: 'excelHtml5',
            text: '<span style="font-size: 3em; color: green;"><i class="fas fa-file-excel fa-sm"></i></span>',
            titleAttr: 'enmail',
            attr: {
              id: 'enmail',
              style: "display:none;",
            },

            exportOptions: {
              columns: [0, 1, 3, 4, 6]
              // columns: [ ':visible' ]
            }
          }, ,
          {
            // extend: 'csvHtml5',
            // text: '<span style="font-size: 3em; color: green;"><i class="fas fa-file-excel fa-sm"></i></span>',
            // titleAttr: 'CSV',
            title: titleValue,
            messageTop: messageTopValue,
            extend: 'excelHtml5',
            text: '<span style="font-size: 3em; color: green;"><i class="fas fa-file-excel fa-sm"></i></span>',
            titleAttr: 'enarabic',
            attr: {
              id: 'enarabic',
              style: "display:none;",
            },
            exportOptions: {
              columns: [0, 2]
              // columns: [ ':visible' ]
            }
          },
          ],
        });
      }, 1);
    });
  }
  exportEnrollmentList() {
    // $("#datatable").() += "<tr><td>"+responseJson1a[i].section+"</td><td>"+responseJson1a[i].metricTotal+"</td></tr>";
    $("#enall").trigger("click");
  }

  exportEnrollmentEmailList() {
    $("#enmail").trigger("click");
  }

  exportEnrollmentArabicList() {
    $("#enarabic").trigger("click");
  }

  searchFormChange() { }
  searchFormSubmit() {
    if (this.searchForm.valid) {
      this.lastSelectYear = this.searchForm.controls.year.value;
      this.lastSelectSemester = this.searchForm.controls.semester.value;
      this.lastSelectBatch = this.searchForm.controls.batch.value;

      if (this.lastSelectYear && this.lastSelectSemester && this.lastSelectBatch) {
        if (this.batches.length > 0) {
          // if(this.globals.lang == 'ar') {
          this.lastSelectBatchName = this.batches.filter((element: any) => element.id == this.lastSelectBatch)[0].gradeNameEn;
          // }else{
          //   this.lastSelectBatchName = this.batches.filter((element: any) => element.id == this.lastSelectBatch)[0].gradeNameEn; 
          // }
        }
        if (this.semesters.length > 0) {
          this.lastSelectSemesterName = this.semesters.filter((element: any) => element.id == this.lastSelectSemester)[0].semesterNameEn;

        }

        this.enrollmentReportService.getAllStudentReport(this.orgId, this.lastSelectYear, this.lastSelectSemester, this.lastSelectBatch)
          .subscribe(
            data => {
              this.students = data;
              if (this.students.length >= 1) {
                this.tableAppear = true;
              } else {
                this.tableAppear = false;
              }
              this.updateTable();
            },
            error => {
              this.toastrService.error(this.translate.instant('CAN_NOT_GET_DATA_BE'));
            }
          );
      } else {
        this.searchForm.controls.batch.reset();
        this.batches = [];
      }

    } else {
      this.searchForm.markAllAsTouched();
      this.searchForm.markAsDirty();
    }
  }

  test() {
    console.log(this.table.rows({ selected: true }).data().toArray());
    // let currentDatatableRows = this.table.rows({ select: 'current' }).data().toArray();
    //.rows({ select: 'current' }).data().toArray()
  }



  showStudentCourses(studMatNo: any) {
    console.log(studMatNo);
    $("#studentCoursesModal").modal('show');
  }


  getYears() {
    this.enrollmentGroupService.getYears()
      .subscribe(
        data => {
          this.years = data;
        },
        error => {
          this.toastrService.error(this.translate.instant('CAN_NOT_GET_DATA_BE'));
        }
      );
  }

  getYearSemesters() {
    let year = this.searchForm.controls.year.value;
    if (year) {
      this.enrollmentGroupService.getYearSemesters(year)
        .subscribe(
          data => {
            this.semesters = data;
          },
          error => {
            this.toastrService.error(this.translate.instant('CAN_NOT_GET_DATA_BE'));
          }
        );
    } else {
      this.searchForm.controls.semester.reset();
      this.semesters = [];
    }
  }

  getBatches() {
    let year = this.searchForm.controls.year.value;
    let semester = this.searchForm.controls.semester.value;
    if (year && semester) {
      this.enrollmentGroupService.getSemesterBatches(this.orgId, year, semester)
        .subscribe(
          data => {
            this.batches = data;
          },
          error => {
            this.toastrService.error(this.translate.instant('CAN_NOT_GET_DATA_BE'));
          }
        );
    } else {
      this.searchForm.controls.batch.reset();
      this.batches = [];
    }
  }
  getBase64(event: any, index: number) {
    let img = event.target;
    let dataURL: any;
    var canvas = document.createElement('canvas');
    let ctx: any;
    ctx = canvas.getContext('2d');
    // canvas.height = img.height;
    // canvas.width = img.width;

    // canvas.height = img.clientHeight;
    // canvas.width = img.clientWidth;

    canvas.height = img.naturalHeight;
    canvas.width = img.naturalWidth;
    // let newWidth = 100;
    // let newHeight = 100;
    ctx.drawImage(img, 0, 0);
    // ctx.drawImage(img, 0, 0);
    dataURL = canvas.toDataURL('image/jpeg');
    this.students[index].imageBase64 = dataURL;
    // console.log("test func: ");
    // console.log(dataURL);
    // console.log("data: ");
    // console.log(this.data);
  }


  async generateExcel() {

    let exportIndexes: any;
    let exportIndexesOrderByHeader: any = [];

    // if (typeof this.exportColumnsSelected != 'undefined' && this.exportColumnsSelected?.length > 0) {

    //   exportIndexes = this.exportColumnsSelected.map((el: any) => el.item_id);
    // }

    // Image propability excel columns
    const imagePropabilityExcelColumns = ['A', 'B', 'C', 'D', 'E', 'F'];
    // Excel Title, Header, Data
    const title = 'Yearly Social Sharing Education For Betterment';
    let header = ["MatNO", "First Name", "Last Name", "Gender", "Profile Picture"]


    // const data = this.candidateInquiriesData;
    const data = this.students;

    // Create workbook and worksheet
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet('student images');


    //   const titleRow = worksheet.addRow(title);
    worksheet.mergeCells('A1:E1');
    worksheet.getCell('A1').value = 'Academic Year ' + this.lastSelectYear;
    worksheet.getCell('A1').alignment = { horizontal: 'center' };

    worksheet.mergeCells('A2:E2');
    worksheet.getCell('A2').value = this.lastSelectSemesterName + ' , ' + this.lastSelectBatchName + '  Batch.';
    worksheet.getCell('A2').alignment = { horizontal: 'center' };
    // Add Header Row
    const headerRow = worksheet.addRow(header);

    // Cell Style : Fill and Border
    headerRow.eachCell((cell, number) => {
      // cell.fill = {
      //   type: 'pattern',
      //   pattern: 'solid',
      //    fgColor: { argb: 'FF002080' },
      //   //bgColor: { argb: 'FF0000FF' }
      // };
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' }
      };
    });
    let imageOptionIndexAtDropdown = 6;
    let imageColumnName = '';

    data.forEach((d: any) => {
      let imageBase64 = d.imageBase64;
      let imageId1 = workbook.addImage({
        base64: imageBase64,
        extension: 'png'
      });
      let rowData = [
        d.matno,
        d.firstNameEn,
        d.lastNameEn,
        d.gender
      ]

      const row = worksheet.addRow(rowData);
      row.height = 100;
      worksheet.addImage(imageId1, imagePropabilityExcelColumns[4] + (4 + imageId1) + ':' + imagePropabilityExcelColumns[4] + (4 + imageId1));

    });
    worksheet.getColumn(3).width = 30;
    worksheet.getColumn(5).width = 20;
    // if (exportIndexes?.length > 0 && exportIndexes.includes(imageOptionIndexAtDropdown)) {
    //   worksheet.getColumn(exportIndexesOrderByHeader.indexOf(imageOptionIndexAtDropdown) + 1).width = 20;
    // } else {
    //   worksheet.getColumn(6).width = 20;
    // }

    workbook.xlsx.writeBuffer().then((data: any) => {
      const blob = new Blob([data], {
        type:
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      });
      fs.saveAs(blob, 'Enrolment-Students-Image.xlsx');
    });
  }

  generateBatchStatisticsReport() {
    let lang = this.globals.lang;
    // this.getBatchStatisticsReport();
    this.enrollmentReportService.generateBatchStaticticsReport(this.orgId, this.lastSelectYear, this.lastSelectSemester, this.lastSelectBatch, lang, this.username)
      .subscribe(
        data => {
          this.getBatchStatisticsReport();
        },
        error => {
          // this.toastrService.error(this.translate.instant('CAN_NOT_GET_DATA_BE'));
          this.toastrService.error(this.translate.instant('CAN_NOT_GENERATE_REPORT_AT_DATA_BE'));
        }
      );
  }

  getBatchStatisticsReport() {
    this.batchStatisticsReport = [];
    this.enrollmentReportService.getBatchStaticticsReport(this.username)
      .subscribe(
        data => {
          if (data.length > 0) {
            data.shift();
            var indexString = this.getKeyByValue(data[1], "<LAST COLUMN>")?.replace("col", "");
            let maxColumn = 0;
            if (indexString) {
              maxColumn = parseInt(indexString);
            }

            let newData = data.map((element: any) => {
              let row: any = {};
              row.rowdesc = element.rowdesc;
              for (let i = 1; i < maxColumn; i++) {
                let indexName = 'col';
                if (i <= 9) {
                  indexName += "0" + i;
                  // row['col0'+i] =
                } else {
                  indexName += i;
                  // row['col'+i] =
                }
                row[indexName] = element[indexName];

              }
              return row;
            });
            this.generateBatchStatisticsReportExcel(newData);
          } else {
            this.toastrService.error(this.translate.instant('NOT_FOUND'));
          }
        },
        error => {
          this.toastrService.error(this.translate.instant('CAN_NOT_GET_DATA_BE'));
        }
      );
  }

  getKeyByValue(object: any, value: any) {
    return Object.keys(object).find(key => object[key] === value);
  }


  async generateBatchStatisticsReportExcel(reportData: any) {


    // Image propability excel columns
    const imagePropabilityExcelColumns = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L'];
    // Excel Title, Header, Data
    const title = 'Yearly Social Sharing Education For Betterment';
    // let header=["MatNO","First Name","Last Name","Gender","Profile Picture"]
    let headerLength = Object.keys(reportData[0]).length;
    let header = Object.values(reportData[0]);


    // const data = this.candidateInquiriesData;
    reportData.shift();
    const data = reportData;

    // Create workbook and worksheet
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet('student images');

    // console.log(headerLength);
    // console.log(imagePropabilityExcelColumns[headerLength+1]);
    //   const titleRow = worksheet.addRow(title);
    worksheet.mergeCells('A1:' + imagePropabilityExcelColumns[headerLength - 1] + '1');
    worksheet.getCell('A1').value = 'Academic Year ' + this.lastSelectYear;
    worksheet.getCell('A1').alignment = { horizontal: 'center' };

    worksheet.mergeCells('A2:' + imagePropabilityExcelColumns[headerLength - 1] + '2');
    worksheet.getCell('A2').value = this.lastSelectSemesterName + ' , ' + this.lastSelectBatchName + '  Batch.';
    worksheet.getCell('A2').alignment = { horizontal: 'center' };
    // Add Header Row
    const headerRow = worksheet.addRow(header);

    // Cell Style : Fill and Border
    headerRow.eachCell((cell, number) => {
      // cell.fill = {
      //   type: 'pattern',
      //   pattern: 'solid',
      //    fgColor: { argb: 'FF002080' },
      //   //bgColor: { argb: 'FF0000FF' }
      // };
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' }
      };
    });
    // let imageOptionIndexAtDropdown = 6;
    // let imageColumnName = '';

    data.forEach((d: any) => {
      // let imageBase64 = d.imageBase64;
      // let imageId1 = workbook.addImage({
      //   base64: imageBase64,
      //   extension: 'png'
      // });
      // let rowData = [
      //   d.matno,
      //   d.firstNameEn,
      //   d.lastNameEn,
      //   d.gender
      // ]
      let rowData = Object.values(d);

      const row = worksheet.addRow(rowData);
      // row.height = 100;
      //   worksheet.addImage(imageId1, imagePropabilityExcelColumns[4] + (4 + imageId1) + ':' + imagePropabilityExcelColumns[4] + (4 + imageId1));

    });
    // worksheet.getColumn(3).width = 30;
    // worksheet.getColumn(5).width = 20;
    // if (exportIndexes?.length > 0 && exportIndexes.includes(imageOptionIndexAtDropdown)) {
    //   worksheet.getColumn(exportIndexesOrderByHeader.indexOf(imageOptionIndexAtDropdown) + 1).width = 20;
    // } else {
    //   worksheet.getColumn(6).width = 20;
    // }

    workbook.xlsx.writeBuffer().then((data: any) => {
      const blob = new Blob([data], {
        type:
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      });
      fs.saveAs(blob, 'Batch-Statistics.xlsx');
    });
  }

}
